import { render, staticRenderFns } from "./AlumnosView.vue?vue&type=template&id=aef9b712&scoped=true&"
import script from "./AlumnosView.vue?vue&type=script&lang=js&"
export * from "./AlumnosView.vue?vue&type=script&lang=js&"
import style0 from "./AlumnosView.vue?vue&type=style&index=0&id=aef9b712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef9b712",
  null
  
)

export default component.exports